import { isEmpty } from 'lodash';

import { CALL_API } from '../../middlewares/api';
import {
    REQUEST_PARTNERS,
    RECEIVE_PARTNERS,
    FAILURE_PARTNERS,
    REQUEST_PARTNER_DETAILS,
    RECEIVE_PARTNER_DETAILS,
    FAILURE_PARTNER_DETAILS
} from './constants';

const shouldFetchPartners = state => {
    const partners = state.partner.partners;
    const fetching = state.partner.fetching;

    if (fetching) {
        return false;
    } else if (isEmpty(partners)) {
        return true;
    } else {
        return false;
    }
};

export const fetchPartnersIfNeeded = () => {
    return {
        [CALL_API]: {
            endpoint: '/partner',
            types: [REQUEST_PARTNERS, RECEIVE_PARTNERS, FAILURE_PARTNERS],
            shouldCallAPI: state => shouldFetchPartners(state)
        }
    };
};

export const forceFetchPartners = () => {
    return {
        [CALL_API]: {
            endpoint: '/partner',
            types: [REQUEST_PARTNERS, RECEIVE_PARTNERS, FAILURE_PARTNERS]
        }
    };
};

const shouldFetchPartnerDetails = (id, state) => {
    const partner = state.partner.partners[id];
    const fetching = partner && state.partner.partners[id].fetching;

    if (fetching) {
        return false;
    } else if (!partner || (partner && !partner.description)) {
        return true;
    } else {
        return false;
    }
};

export const fetchPartnerDetailsIfNeeded = (id, lazy = true) => {
    return {
        [CALL_API]: {
            endpoint: `/partner/${id}${lazy ? '/lazy' : ''}`,
            payload: { id },
            types: [REQUEST_PARTNER_DETAILS, RECEIVE_PARTNER_DETAILS, FAILURE_PARTNER_DETAILS],
            shouldCallAPI: state => shouldFetchPartnerDetails(id, state)
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/partner/actions.js